import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const ok: Platform = {
  id: 'ok',
  name: 'Одноклассники',
  iconIndex: PlatformRegistry.ok.index,
  color: PlatformRegistry.ok.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://connect.ok.ru/offer', {
      url: content.url,
      title: content.title,
      imageUrl: content.image,
    });
  },
};

